export const setOrdInQuerySearchParams = (sortType) => `?page=1&ord=${sortType}`;